import { http, HttpResponse } from 'msw'

import { allMachines } from 'app/mocks/data/machines/all'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

export const getAllMachines = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.ALL}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilterSimple = searchParams.get('site__client')
        const managerIdsFilter = searchParams.get('site__client__in')
        const clientIdsFilterSimple = searchParams.get('site__customer_name')
        const clientIdsFilter = searchParams.get('site__customer_name__in')
        const siteIdsFilterSimple = searchParams.get('site')
        const siteIdsFilter = searchParams.get('site__in')
        const categoriesFilter = searchParams.getAll('category__in[]')
        const nameFilter = searchParams.get('name__icontains')

        let allMachinesFiltered = allMachines

        // Manager filter simple (to delete when refactoring the page)
        if (managerIdsFilterSimple) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilterSimple)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                managerIdsSplit.includes(machine.site.customer_name.client.id),
            )
        }

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                managerIdsSplit.includes(machine.site.customer_name.client.id),
            )
        }

        // Client filter simple (to delete when refactoring the page)
        if (clientIdsFilterSimple) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilterSimple)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                clientIdsSplit.includes(machine.site.customer_name.client.id),
            )
        }

        // Client filter
        if (clientIdsFilter) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilter)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                clientIdsSplit.includes(machine.site.customer_name.id),
            )
        }

        // Site filter simple (to delete when refactoring the page)
        if (siteIdsFilterSimple) {
            const siteIdsSplit = queryIntoArrayNumber(siteIdsFilterSimple)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                siteIdsSplit.includes(machine.site.id),
            )
        }

        // Site filter
        if (siteIdsFilter) {
            const siteIdsSplit = queryIntoArrayNumber(siteIdsFilter)

            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                siteIdsSplit.includes(machine.site.id),
            )
        }

        // Categories filter
        if (categoriesFilter.length > 0) {
            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                categoriesFilter.includes(machine.category),
            )
        }

        // Name filter
        if (nameFilter) {
            allMachinesFiltered = allMachinesFiltered.filter((machine) =>
                machine.name.toLowerCase().includes(nameFilter),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allMachinesFiltered.length > limit
                ? offset + limit
                : allMachinesFiltered.length

        const results = allMachinesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allMachinesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json({
            count: allMachinesFiltered.length,
            next,
            results,
        })
    },
)
